import { InputField, OutlineButton, PrimaryButton } from 'client/CommonComponents'
import './EditFilter.scss'
import CompleteConfirmationPopup from 'client/CommonComponents/DialogBox/CompleteConfirmationPopup'

const Editfilter = (props?: any) => {
    const {
        changedCapacityValue,
        onEditValueChange,
        onAddClick,
        isValidForSave,
        onClickCancel,
        hideDialog,
        popUpContent
    } = props

    return (
        <>
            <div className='editcapacity_overflow'>
                {changedCapacityValue?.length ? changedCapacityValue?.map((item?: any) => {
                    if (item?.value != null) {
                        return (
                            <>
                                <div>
                                    <InputField
                                        placeholder="Enter Capacity"
                                        name='capacity'
                                        onChange={(e: any) => onEditValueChange(e, item?.value)}
                                        value={item?.label}
                                        className={`capacity_popup_textbox ${item?.error?.length ? "controlValidation" : ''}`}
                                     data-attribute="EditFilter_capacity_Input" />
                                </div>
                                {item?.error?.length ? <p className='validMessage editcapacity_validmessage'>{item?.error}</p> : ""}
                            </>
                        )
                    }
                }) : null}
            </div>
            <div className='editcapacity_popup'>
                <OutlineButton
                    text='Cancel'
                    className='pull-right add-vehicle-level ms-3 editcapacity_cancel'
                    onClick={onClickCancel}
                 data-attribute="EditFilter_Default_Button" />
                <PrimaryButton
                    text='Add'
                    className='pull-right add-vehicle-level ms-3'
                    onClick={onAddClick}
                    disabled={isValidForSave()}
                 data-attribute="EditFilter_Default_Button_2" />
            </div>
            <CompleteConfirmationPopup
                hideDialog={hideDialog}
                onDismiss={popUpContent?.popupOutlinebtnOnclick}
                Popupcontent={popUpContent}
                popupOutlinebtnOnclick={popUpContent?.popupOutlinebtnOnclick}
                popupPrimarybtnOnclick={popUpContent?.popupPrimarybtnOnclick}
            />
        </>
    )

}

export default Editfilter;


